import { useApi } from 'ApiHooks'
import { useBlockUI } from 'Context/BlockUIContext'
import { useErrorModal } from 'Context/ErrorModalContext'
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { useIsMobile } from 'utils/Utils'


interface ModalVerEstadoDespachoProps {
    showModalVerEstadoDespacho: boolean
    setShowModalVerEstadoDespacho: Dispatch<SetStateAction<boolean>>
    onClose: () => void
}

const ModalVerEstadoDespacho = (props: ModalVerEstadoDespachoProps) => {
    const { showModalVerEstadoDespacho, onClose } = props

    const api = useApi()
    const { showError } = useErrorModal()
    const { showBlock, hideBlock } = useBlockUI()
    const isMobile = useIsMobile()
    const [sigea, setSigea] = useState<string>('')
    const [tipoLote, setTipoLote] = useState<string>('000')
    const [nroDespacho, setNroDespacho] = useState<string>('')
    const [tiposLote, setTiposLote] = useState<{ value: string, label: string }[]>([])
    const [descripcionEstadoDespacho, setDescripcionEstadoDespacho] = useState<string>('')
    const [codigoErrorEstadoDespacho, setCodigoErrorEstadoDespacho] = useState<number>(0)

    const verEstadoDespacho = async () => {
        showBlock("Consultando estado de Despacho...")
        try {
            const response: any = await api.obtenerEstadoDespacho({
                "despachos": [
                    {
                        "despacho": nroDespacho,
                        "codigo": tipoLote,
                        "sigea": sigea
                    }]
            })
            const descripcion = (Object?.values(response)[0] as any)?.descripcion
            const codigoErrorEstado = (Object?.values(response)[0] as any)?.codigo
            setDescripcionEstadoDespacho(descripcion)
            setCodigoErrorEstadoDespacho(codigoErrorEstado)
            hideBlock()
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al obtener estado de despacho',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',

                })
            }
        } finally {
            hideBlock()
        }
    }

    const obtenerListadoTipoDeLote = async () => {
        showBlock("Obteniendo listado de tipos de Lote...")
        try {
            const response = await api.obtenerListadoTiposDeLote()
            setTiposLote(response.map((item: any) => ({
                value: item?.codigo,
                label: item?.nombre,
            })))
            hideBlock()
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al obtener la lista de unidades de negocio',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',
                })
            }
        } finally {
            hideBlock()
        }
    }

    useEffect(() => {
        if (showModalVerEstadoDespacho) {
            obtenerListadoTipoDeLote()
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [showModalVerEstadoDespacho])

    return (
        <Modal
            show={showModalVerEstadoDespacho}
            onHide={onClose}
            size="lg"
            centered
            scrollable
            style={{ backgroundColor: 'rgba(1,1,1,0.5)' }}

        >
            <Modal.Header closeButton={false}>
                <div className="w-100 d-flex align-items-center justify-content-between">
                    <Modal.Title style={{ color: 'white', fontWeight: 'bold' }}>
                        Ver Estado de Despacho
                    </Modal.Title>
                </div>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Row>
                        <Col md="auto">
                            <Form.Group>
                                <label className="fw-bold mb-1"><b>Nro. Despacho</b></label>
                                <Form.Control
                                    name="nroDespacho"
                                    value={nroDespacho}
                                    onChange={(e) => setNroDespacho(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md="auto">
                            <label className="fw-bold mb-1"><b>Tipo de lote</b></label>
                            <select
                                className="form-control"
                                value={tipoLote}
                                onChange={(e) => setTipoLote(e.target.value)}
                            >
                                {tiposLote?.map((tipo) => (
                                    <option key={tipo.value} value={tipo.value}>{tipo.label}</option>
                                ))}
                            </select>
                        </Col>
                        {tipoLote !== '000' && <Col md="auto" style={{ marginTop: isMobile ? 10 : 0 }}>
                            <Form.Group>
                                <label className="fw-bold mb-1"><b>SIGEA</b></label>
                                <Form.Control
                                    name="sigea"
                                    value={sigea}
                                    onChange={(e) => setSigea(e.target.value)}
                                />
                            </Form.Group>
                        </Col>}
                        <Col md="auto">
                            <Button type='primary' style={{ marginTop: isMobile ? 10 : 22 }} onClick={(e) => {
                                e?.preventDefault()
                                verEstadoDespacho()
                            }}>Consultar</Button>
                        </Col>
                        {descripcionEstadoDespacho && <Col md="12" style={{ marginTop: 10 }}>
                            <Form.Group>
                                <Form.Label>Descripción Estado Despacho</Form.Label>
                                <Form.Control as="textarea" disabled style={{ color: codigoErrorEstadoDespacho !== 0 ? 'red' : 'black' }} value={descripcionEstadoDespacho} rows={3} />
                            </Form.Group>
                        </Col>}
                    </Row>

                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalVerEstadoDespacho